<template>
  <div>
    <slot :weeks="weeks"></slot>
  </div>
</template>

<script>
import { eachWeekOfInterval, getWeek, getWeekYear, startOfWeek } from 'date-fns'
export default {
  name: 'GeneratorWeeks',
  props: {
    startDate: {type: Date, required: true},
    endDate: {type: Date, required: true},
    year: {type: Number, required: false}
  },
  computed: {
    weeks () {
      return eachWeekOfInterval({
        start: startOfWeek(this.startDate, {weekStartsOn: 1}),
        end: this.endDate
      }, {weekStartsOn: 1})
        .filter(date => {
          const weekYear = getWeekYear(date, { weekStartsOn: 1, firstWeekContainsDate: 4 });
          const weekNb = getWeek(date, { weekStartsOn: 1, firstWeekContainsDate: 4 });
          return !this.year ||
              weekYear === this.year ||
              (weekYear === this.year + 1 && weekNb === 1);
        })
        .map(week => ({text: getWeek(week, { weekStartsOn: 1, firstWeekContainsDate: 4 }), value: week}))
    },
  },
}
</script>
